import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';

export const useOptimisticCredits = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const updateCreditsOptimistically = (creditsDelta: number) => {
    if (!user) return;

    queryClient.setQueryData(['subscription-status', user.id], (oldData: any) => {
      if (!oldData) return oldData;
      
      return {
        ...oldData,
        credits_left: Math.max(0, (oldData.credits_left || 0) + creditsDelta)
      };
    });
  };

  const refreshCredits = () => {
    if (!user) return;
    
    // Invalidate both query keys during transition period to ensure all components refresh
    queryClient.invalidateQueries({ queryKey: ['subscription-status', user.id] });
    queryClient.invalidateQueries({ queryKey: ['user-credits', user.id] });
  };

  return {
    updateCreditsOptimistically,
    refreshCredits,
  };
};